interface WorkspaceData {
  id: string;
  workspaceRules?: Array<{
    params?: {
      payload?: {
        rules?: {
          rulesRegister?: {
            policyContractNumber?: string;
          };
        };
      };
    };
  }>;
  product: {
    name: string;
    supplierOrganization: {
      corporateName: string;
    };
  };
}

/**
 * Extracts the contract display name from workspace data.
 * Uses policyContractNumber if available, otherwise falls back to UUID.
 *
 * @param data - Workspace data containing id, workspaceRules, and product info
 * @returns Formatted contract display name
 */
export function getContractDisplayName(data: WorkspaceData): string {
  const policyContractNumber = data.workspaceRules?.[0]?.params?.payload?.rules?.rulesRegister?.policyContractNumber?.trim();
  const contractId = policyContractNumber || data.id.split("-")[0].toUpperCase();

  return `${contractId} - ${data.product.supplierOrganization.corporateName} - ${data.product.name}`;
}
